<template>
    <v-main>
      <router-view/>
    </v-main>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
<style lang="scss" scoped>
table.v-table thead th {
  font-size: 20px !important;
}
table.v-table tbody td {
  font-size: 12px !important;
}
</style>
